import advancedFilters from './advancedFilters.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import bulkActions from './bulkActions.json';
import chatlist from './chatlist.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import emoji from './emoji.json';
import generalSettings from './generalSettings.json';
import inboxMgmt from './inboxMgmt.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import foldersMgmt from './foldersMgmt.json';
import login from './login.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import whatsappTemplates from './whatsappTemplates.json';
import whatsNew from './whatsNew.json';
import general from './general.json';
import datePicker from './datePicker.json';
import agentAI from './agentAI.json';
import automationPanel from './automationPanel.json';
import settingsCenter from './settingsCenter.json';
import accountAnalytics from './accountAnalytics.json';
import onboarding from './onboarding.json';

export default {
  ...advancedFilters,
  ...agentMgmt,
  ...attributesMgmt,
  ...bulkActions,
  ...chatlist,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...emoji,
  ...generalSettings,
  ...inboxMgmt,
  ...integrations,
  ...labelsMgmt,
  ...foldersMgmt,
  ...login,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...whatsappTemplates,
  ...whatsNew,
  ...general,
  ...datePicker,
  ...agentAI,
  ...automationPanel,
  ...settingsCenter,
  ...accountAnalytics,
  ...onboarding,
};
